/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrainingPlayer
 */
export interface TrainingPlayer {
    /**
     * All given names, preserved separately for display formatting.
     * @type {string}
     * @memberof TrainingPlayer
     */
    playerFirstName?: string | null;
    /**
     * All family names, preserved separately for display formatting.
     * @type {string}
     * @memberof TrainingPlayer
     */
    playerLastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingPlayer
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingPlayer
     */
    playerId?: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingPlayer
     */
    playerName?: string;
    /**
     * 
     * @type {number}
     * @memberof TrainingPlayer
     */
    playerNumber?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TrainingPlayer
     */
    baseFeeOverride?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TrainingPlayer
     */
    effectiveBaseFee?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingPlayer
     */
    invitedEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingPlayer
     */
    invitationStatus?: string;
    /**
     * 
     * @type {Date}
     * @memberof TrainingPlayer
     */
    invitationSentAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingPlayer
     */
    claimedByEmail?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TrainingPlayer
     */
    claimedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof TrainingPlayer
     */
    joinedDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof TrainingPlayer
     */
    active?: boolean;
}

/**
 * Check if a given object implements the TrainingPlayer interface.
 */
export function instanceOfTrainingPlayer(value: object): value is TrainingPlayer {
    return true;
}

export function TrainingPlayerFromJSON(json: any): TrainingPlayer {
    return TrainingPlayerFromJSONTyped(json, false);
}

export function TrainingPlayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainingPlayer {
    if (json == null) {
        return json;
    }
    return {
        
        'playerFirstName': json['playerFirstName'] == null ? undefined : json['playerFirstName'],
        'playerLastName': json['playerLastName'] == null ? undefined : json['playerLastName'],
        'id': json['id'] == null ? undefined : json['id'],
        'playerId': json['playerId'] == null ? undefined : json['playerId'],
        'playerName': json['playerName'] == null ? undefined : json['playerName'],
        'playerNumber': json['playerNumber'] == null ? undefined : json['playerNumber'],
        'baseFeeOverride': json['baseFeeOverride'] == null ? undefined : json['baseFeeOverride'],
        'effectiveBaseFee': json['effectiveBaseFee'] == null ? undefined : json['effectiveBaseFee'],
        'invitedEmail': json['invitedEmail'] == null ? undefined : json['invitedEmail'],
        'invitationStatus': json['invitationStatus'] == null ? undefined : json['invitationStatus'],
        'invitationSentAt': json['invitationSentAt'] == null ? undefined : (new Date(json['invitationSentAt'])),
        'claimedByEmail': json['claimedByEmail'] == null ? undefined : json['claimedByEmail'],
        'claimedAt': json['claimedAt'] == null ? undefined : (new Date(json['claimedAt'])),
        'joinedDate': json['joinedDate'] == null ? undefined : (new Date(json['joinedDate'])),
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function TrainingPlayerToJSON(json: any): TrainingPlayer {
    return TrainingPlayerToJSONTyped(json, false);
}

export function TrainingPlayerToJSONTyped(value?: TrainingPlayer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'playerFirstName': value['playerFirstName'],
        'playerLastName': value['playerLastName'],
        'id': value['id'],
        'playerId': value['playerId'],
        'playerName': value['playerName'],
        'playerNumber': value['playerNumber'],
        'baseFeeOverride': value['baseFeeOverride'],
        'effectiveBaseFee': value['effectiveBaseFee'],
        'invitedEmail': value['invitedEmail'],
        'invitationStatus': value['invitationStatus'],
        'invitationSentAt': value['invitationSentAt'] == null ? value['invitationSentAt'] : value['invitationSentAt'].toISOString(),
        'claimedByEmail': value['claimedByEmail'],
        'claimedAt': value['claimedAt'] == null ? value['claimedAt'] : value['claimedAt'].toISOString(),
        'joinedDate': value['joinedDate'] == null ? value['joinedDate'] : value['joinedDate'].toISOString(),
        'active': value['active'],
    };
}

